import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import { isValidURL } from 'modules/core/lib/url'

interface FormInitialValues {
  system_and_defense_custom_url?: string | null
  privacy_policy_custom_url?: string | null
}

export class PrivacyPolicyForm extends Form {
  constructor(values: FormInitialValues) {
    super(values, {
      system_and_defense_custom_url: 'string',
      privacy_policy_custom_url: 'string',
    })

    makeObservable(this, {
      isValid: computed,
    })
  }

  get isValid(): boolean {
    const systemDefenseValue = this.get('system_and_defense_custom_url').value
    const privacyPolicyValue = this.get('privacy_policy_custom_url').value

    const isSystemDefenseValid =
      (systemDefenseValue !== '' && isValidURL(systemDefenseValue)) || systemDefenseValue === ''
    const isPrivacyPolicyValid =
      (privacyPolicyValue !== '' && isValidURL(privacyPolicyValue)) || privacyPolicyValue === ''

    return isSystemDefenseValid && isPrivacyPolicyValid
  }
}
